import forEach from "lodash/forEach";
import includes from 'lodash/includes'
import slice from 'lodash/slice'

import apiCalls from "@/mixins/apiCalls.js";
const APP_ACTION = false

export default {
  mixins: [apiCalls],
  data() {
    return {
      userSubscriptions: null,
      subscriptionsTypes: [],
      subscriptionsByTypes: {},
      internationalServices: {},
      internationalServicesTypes: [],
      allCategories: [],
      extraPackages: {},
      roamingPackages: null,
      roamingPackagesByTypes: {},
      roamingPackagesTypes: []
    }
  },
  methods: {
    async fetchUserSubscriptions() {
        this.loaded = false;
        // console.log('fetch subscr', this.user.domain_user_id);
        const functionName = 'get_user_subscriptions'
        const reqBody = {
          domain_user_id: this.$route.params.id, //this.user.domain_user_id
        };
        const data = await this.makeApiRequest(APP_ACTION, functionName, reqBody);
        if (data.error_code === 200) {
        this.userSubscriptions = data.data
        if(this.isAbroad) this.extractInternationalCategories()
        else this.separateByCategories();
        this.loaded = true;
      }
    },
    extractInternationalCategories() {
      // console.log('extractInternationalCategories', this.userSubscriptions);
      const internationalServices = ['international_calls', 'roaming', 'extra_did']
      return forEach(this.userSubscriptions, (el) => {
        // console.log('el in this.userSubscriptions ', el, this.internationalServicesTypes055);
        if (includes(internationalServices, el.service_details.category) && includes(this.internationalServicesTypes, el.service_details.category)) {
          // console.log('el.service_id', el.service_id, this.internationalServices);
          if(el.service_id != 54) this.internationalServices[`${el.service_details.category}`].push(el);   
          // if(el.service_id != 54) this.internationalServices[`${el.service_details.category}`].push(el);   
        }
        if (includes(internationalServices, el.service_details.category) && !includes(this.internationalServicesTypes, el.service_details.category)) {
          // console.log('el.service_id second case', el.service_id !== 54,el.service_id != 54, el.service_id, this.internationalServices);
          if(el.service_id != 54) {
            // console.log('el.service_id is 55 push', el.service_id, this.internationalServices);

            this.internationalServicesTypes.push(el.service_details.category);
          } 
          if(el.service_id != 54) this.$set(
            this.internationalServices,
            `${el.service_details.category}`,
            []
            );
            if(el.service_id != 54)  this.internationalServices[`${el.service_details.category}`].push(el);
          }
        })
      },
      extractInternationalPackages() {
        const internationalServices = ['international_calls', 'roaming', 'extra_did']
        return forEach(this.roamingPackages, (el) => {
          if (includes(internationalServices, el.profile) && includes(this.roamingPackagesTypes, el.profile)) {
            
            this.roamingPackagesByTypes[`${el.profile}`].push(el);
          }
          if (includes(internationalServices, el.profile) && !includes(this.roamingPackagesTypes, el.profile)) {
            this.roamingPackagesTypes.push(el.profile);
            this.$set(
              this.roamingPackagesByTypes,
              `${el.profile}`,
              []
              );
              this.roamingPackagesByTypes[`${el.profile}`].push(el);
            }
          })
        },
    separateByCategories() {
      const internationalServices = ['international_calls', 'roaming']
      // console.log('separateByCategories ', this.userSubscriptions, this.userSubscriptions.length );
      return forEach(this.userSubscriptions, (el) => {
        // console.log('el : ', el );
        if( includes(this.subscriptionsTypes, el.service_details.category)&& !includes(internationalServices, el.service_details.category)) {
          // console.log('included before  : ', el.service_details.category );
          if(el.service_id != 55)  this.subscriptionsByTypes[`${el.service_details.category}`].push(el);
        }
        if (!includes(this.subscriptionsTypes, el.service_details.category) && !includes(internationalServices, el.service_details.category)) {
          // console.log('not included before  : ', el.service_details.category );
          if(el.service_id != 55) this.subscriptionsTypes.push(el.service_details.category);
          if(el.service_id != 55) this.$set(
            this.subscriptionsByTypes,
            `${el.service_details.category}`,
            []
          );
          if(el.service_id != 55) this.subscriptionsByTypes[`${el.service_details.category}`].push(el);
        }
      });
    },
   
    async fetchRoamingPackages() {
      this.loaded = false;
      const appAction = false;
      const functionName = "get_packages_with_info"; 
      const reqBody = {
        package_types: ["extra"],
        reseller_domain_id: null, 
      };
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      if (data.error_code === 200) {
        this.roamingPackages = data.data.items 
        this.extractInternationalPackages()
        this.loaded = true;
      }
    },
    // TODO - create one function that will recieve parameters- what to extract and maybe type - 
    // subscription/package and will do the same as all functions here that filter some vals
    extractExtras() {
      const internationalServices = ['international_calls', 'roaming']
      return forEach(this.allPackages, (el) => {
        if( this.extraPackages[`${el.profile}`] && !includes(internationalServices, el.profile)) {
          this.extraPackages[`${el.profile}`].push(el);
        }
        if (!this.extraPackages[`${el.profile}`] && !includes(internationalServices, el.profile)) {
          this.$set(
            this.extraPackages,
            `${el.profile}`,
            []
          );
          this.extraPackages[`${el.profile}`].push(el);
        }
      });
    },
    async fetchExtraDidPackages() {
      this.loaded = false;
      const appAction = false;
      const functionName = "get_packages_with_info";
      const reqBody = {
        package_types: ["extra"],
        profile: ['extra_did'],
        reseller_domain_id: null, 
      };
      const data = await this.makeApiRequest(appAction, functionName, reqBody);
      if (data.error_code === 200) {
        let temp = slice(data.data.items, 0, 8) //hardcoding slice
        this.extraDidPackages = [temp[2], temp[7]]
        this.loaded = true;
      }
    },
   
  }
}